import type { Stage } from './types'

export const RECENCY = ['all', '7', '30', 'older', 'never'] as const
export type CustomerFilter = { q: string; stage: Stage | 'all'; owner: string; region: string; recency: (typeof RECENCY)[number]; category: string }
export const EMPTY_CUSTOMER_FILTER: CustomerFilter = { q: '', stage: 'all', owner: 'all', region: 'all', recency: 'all', category: 'all' }
